import React from 'react';
import classNames from 'classnames';
import { useRouter, useSearchParams } from 'next/navigation';

// components
import Icon from './Icon';
import Text from './Text';

function StoreLocator({ isHamBurgerMenu = false }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const isOpenMenu = searchParams?.get('is-menu-open') ?? '';
  const current = new URLSearchParams(Array.from(searchParams.entries()));

  const handleStoreLocator = () => {
    let query = '';

    if (isHamBurgerMenu && isOpenMenu) {
      const updatedParams = new URLSearchParams(current);
      if (isOpenMenu) {
        updatedParams.delete('is-menu-open');
      }
      query = updatedParams.toString();
    }

    const fullPath = query ? `/store-locator?${query}` : '/store-locator';
    router.push(fullPath);
  };

  return (
    <div
      className={classNames('store-locator', {
        'border border-senate px-8 py-4 rounded-[50px]': isHamBurgerMenu,
      })}
    >
      <div
        className="flex items-center gap-[4px] hover:cursor-pointer"
        onClick={handleStoreLocator}
      >
        <Icon type="location" color={isHamBurgerMenu ? '#49525E' : '#FFFFFF'} />
        <Text
          type="paragraph"
          className={classNames(
            'text-14 lg:text-16 font-encode-sans font-medium leading-20 tracking-[0.32px]',
            {
              'text-senate': isHamBurgerMenu,
            },
          )}
        >
          Store Locator
        </Text>
      </div>
    </div>
  );
}

export default StoreLocator;
